import { Skeleton } from 'antd';
import styled from 'styled-components';

export const SecureTableContainer = styled.div`
  padding: 8px;
`;

export const SecureTable = styled.table`
  width: 100%;
  border-spacing: 0 8px;
  border-collapse: separate;
  margin: -8px 0;

  & tr {
    & > td:nth-child(odd) {
      white-space: nowrap;
      padding-left: 30px;
    }
    & > td:nth-child(even) {
      padding-left: 2px;
    }
    & > td:first-child {
      padding-left: 0;
      white-space: nowrap;
    }
  }

  &.expand-ara {
    & tr {
      & td:nth-child(3) {
        padding-left: 25px;
      }

      & td:nth-child(4) {
        padding-left: 10px;
        padding-right: 4px;
      }
    }
  }
`;

export const SecureTableRow = styled.tr<{
  minWidth?: number[];
}>`
  ${({ minWidth = [] }) =>
    minWidth.map(
      (width, idx) => `
        & > td:nth-child(${idx + 1}) {
          min-width: ${width}px;
        }`,
    )}
`;

export const SecureTableData = styled.td`
  color: ${({ color }) => `${color || '#333333'}`};
  text-align: ${({ align }) => align};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 0;
  white-space: nowrap;

  &.single-line {
    padding-right: 0 !important;
  }

  &.single-line > div:hover {
    cursor: pointer;
  }
`;

export const SecureTableDataClickable = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SecureTableTbodySkeleton = styled.tbody`
  & tr > td {
    width: 40px;
    height: 16px;

    &:nth-child(odd) {
      padding: 0;
    }

    & > div {
      padding: 0 2px;
      display: flex;
      width: 100%;
      & > span.ant-skeleton-button {
        width: 100%;
      }
    }
  }
`;

export const TableSecureColumnSkeleton = styled(Skeleton.Button)`
  & > .ant-skeleton-button {
    height: 16px;
    vertical-align: middle;
  }
`;
